import { createHookContext } from '@clover-util/react-context';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import FiIntegrationUtils from 'utils/FiIntegrationUtils';

export interface IMerchantProspectData {
  firstName?: string;
  lastName?: string;
  businessName?: string;
  emailAddress?: string;
  zipCode?: string;
  mobilePhoneNumber?: string;
  chainAgentId?: string;
}

export const fiRoutes = ['/privacy-policy', '/purchase', '/terms'];

export const { FiMerchantProvider, useFiMerchant } = createHookContext('FiMerchant', () => {
  const queryParam = FiIntegrationUtils.getSubscriberRefIdQueryParam();
  const [subscriberRefId, setSubscriberRefId] = useState<string | undefined>(queryParam);
  const [merchantProspectData, setMerchantProspectData] = useState<IMerchantProspectData>();
  const [hasFailedFetchingMerchantProspectData, setHasFailedFetchingMerchantProspectData] = useState(false);

  const location = useLocation();

  const isBankingOffer = location.pathname.includes('/purchase/banking-offer');

  const isFiAllowedPage = isBankingOffer
    ? isBankingOffer
    : fiRoutes.some(page => location.pathname.includes(page));

  const isFiMerchant = Boolean(subscriberRefId);

  const shouldHideHeaderFooterForFi = isFiMerchant && isFiAllowedPage;

  /* We are checking against merchantProspectData here because we do not want
   * to redirect the user to /banking-offer before the fetch to retrieve
   * merchantProspectData occurs.
   */
  const shouldRedirectFiUser = isFiMerchant && merchantProspectData && !isFiAllowedPage;

  return {
    shouldHideHeaderFooterForFi,
    shouldRedirectFiUser,
    subscriberRefId,
    setSubscriberRefId,
    merchantProspectData,
    setMerchantProspectData,
    hasFailedFetchingMerchantProspectData,
    setHasFailedFetchingMerchantProspectData,
  };
});
